import { Link } from "react-router-dom";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Super Admin "Subscriber view" control. Shown only when the backend reports the
// permission (authenticated super_admin). Lets the owner preview the subscriber
// experience, including locked-content layouts. Server-enforced, downgrade-only.
export function DevPreviewBanner() {
  const { user, previewMode, togglePreview } = useAuth();
  if (!user || !user.dev_preview_enabled || user.role === "creator") return null;
  const back = user.role === "super_admin" ? "/admin" : "/creator/dashboard";
  return (
    <div
      data-testid="dev-preview-banner"
      className="sticky top-0 z-50 border-b border-[#6a00ff]/40 bg-[#0c0a10]/95 px-4 py-2.5 backdrop-blur"
    >
      <div className="mx-auto flex max-w-md items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 text-[0.6rem] font-bold uppercase tracking-wider text-[#c9a6ff]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#d42be8]" /> Super Admin Preview
          </p>
          <p className="truncate text-[0.6rem] text-[#a7a0af]">
            {previewMode ? "Viewing as a subscriber — locked layouts shown" : "Viewing with full admin access"}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            onClick={togglePreview}
            data-testid="dev-preview-toggle"
            className={`flex items-center gap-1 rounded-full px-3 py-1.5 text-[0.65rem] font-semibold ${
              previewMode ? "btn-brand text-white" : "border border-white/15 text-white"
            }`}
          >
            {previewMode ? <><EyeOff size={12} /> Subscriber view: ON</> : <><Eye size={12} /> Subscriber view: OFF</>}
          </button>
          <Link
            to={back}
            data-testid="dev-preview-exit"
            className="rounded-full border border-white/15 p-1.5 text-[#a7a0af] hover:text-white"
            title="Back to studio"
          >
            <ArrowLeft size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
